module.exports = __webpack_public_path__ + "img/wl.9d03cf90.png";